// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import React from 'react';
import ReactPlayer from 'react-player';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import play from '../../../../images/home-play.svg';

const VideoBlock = ({
  classes,
  video_block_title,
  video_link,
}) => {

  return (
    <div className={classes.mainContainer}>
      <div className={classes.titleContainer}>
        <h1 className={classes.titleText}>{parse(video_block_title)}</h1>
      </div>
      <div className={classes.descriptionContainer}>
        <div className={classes.playImageContainer}>
          <img className={classes.playImage} src={play} alt={'play'} />
        </div>
        <p className={classes.descriptionText}>How It Work</p>
      </div>
      <div className={classes.playerContainer}>
        <ReactPlayer
          width={'100%'}
          height={'100%'}
          controls={true}
          url={video_link}
        />
      </div>
    </div>
  );
};

VideoBlock.propTypes = {
  classes: PropTypes.object,
  video_block_title: PropTypes.string,
  video_link: PropTypes.string,
};

VideoBlock.defaultProps = {
  classes: {},
  video_block_title: '',
  video_link: '',
};


export default withStyles(styles)(VideoBlock);
